<template>
  <div class="terms-page">
    <div class="terms-container">
      <div class="header">
        <h1>{{ $t('legal.termsOfService') }}</h1>
        <div class="header-divider"></div>
      </div>
      
      <div class="content">
        <section>
          <h2>{{ $t('legal.terms.section1.title') }}</h2>
          <p>{{ $t('legal.terms.section1.content') }}</p>
        </section>

        <section>
          <h2>{{ $t('legal.terms.section2.title') }}</h2>
          <p>{{ $t('legal.terms.section2.content') }}</p>
        </section>

        <section>
          <h2>{{ $t('legal.terms.section3.title') }}</h2>
          <p>{{ $t('legal.terms.section3.content') }}</p>
        </section>

        <section>
          <h2>{{ $t('legal.terms.section4.title') }}</h2>
          <p>{{ $t('legal.terms.section4.content') }}</p>
        </section>

        <section>
          <h2>{{ $t('legal.terms.section5.title') }}</h2>
          <p>{{ $t('legal.terms.section5.content') }}</p>
        </section>

        <section>
          <h2>{{ $t('legal.terms.section6.title') }}</h2>
          <p>{{ $t('legal.terms.section6.content') }}</p>
        </section>

        <div class="last-updated">
          {{ $t('legal.lastUpdated') }}: 2024年1月1日
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style scoped>
.terms-page {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
}

.terms-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  padding: 30px 35px 40px;
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.header {
  text-align: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
}

.header h1 {
  margin: 0 0 10px 0;
  color: #2c3e50;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: -0.5px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.header-divider {
  width: 60px;
  height: 3px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  margin: 0 auto;
  border-radius: 2px;
}

.content {
  line-height: 1.7;
  color: #4a5568;
  font-size: 15px;
}

section {
  margin-bottom: 20px;
  padding: 18px 20px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;
}

section:hover {
  background: #f1f3f5;
  border-left-color: #667eea;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
}

section h2 {
  color: #2c3e50;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  padding-left: 0;
  border-left: none;
  position: relative;
}

section h2::before {
  content: '';
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%);
  width: 5px;
  height: 5px;
  background: #667eea;
  border-radius: 50%;
}

section p {
  margin-bottom: 8px;
  text-align: justify;
  color: #4a5568;
  line-height: 1.7;
}

section p:last-child {
  margin-bottom: 0;
}

.last-updated {
  margin-top: 30px;
  padding-top: 15px;
  border-top: 1px solid #e9ecef;
  color: #6c757d;
  font-size: 13px;
  text-align: center;
  font-style: italic;
}

@media (max-width: 768px) {
  .terms-page {
    padding: 15px 10px;
  }
  
  .terms-container {
    padding: 20px 18px;
    border-radius: 10px;
  }
  
  .header {
    margin-bottom: 20px;
    padding-bottom: 12px;
  }
  
  .header h1 {
    font-size: 26px;
  }
  
  .header-divider {
    width: 50px;
    height: 2px;
  }
  
  section {
    padding: 15px;
    margin-bottom: 15px;
  }
  
  section h2 {
    font-size: 18px;
    margin-bottom: 10px;
  }
  
  .content {
    font-size: 14px;
  }
  
  .last-updated {
    margin-top: 25px;
    padding-top: 12px;
  }
}

@media (max-width: 480px) {
  .terms-page {
    padding: 10px 8px;
  }
  
  .terms-container {
    padding: 18px 15px;
  }
  
  .header h1 {
    font-size: 22px;
  }
  
  section {
    padding: 12px;
    margin-bottom: 12px;
  }
  
  section h2 {
    font-size: 16px;
  }
  
  .content {
    font-size: 13px;
  }
}
</style> 